import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../Layout/Layout";
import "../AccessApi/AccessApi.scss";

import { RootState } from "../../redux/rootReducers";
import {
  fetchMerchantSecret,
  regenerateMerchantSecret,
} from "../../redux/actions/accessApi";
import { useLocation, useParams } from "react-router-dom";

const MerchantSecret: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const authApi = useSelector((state: RootState) => state.authReducer);
  const { id } = useParams();

  const merchantId = useMemo(() => {
    if (id) return id;
    return undefined;
  }, [id]);

  const { token } = authApi;

  const merchantSecretState = useSelector(
    (state: RootState) => state.merchantSecretReducer
  );

  const {
    loading: secretLoading,
    error: secretError,
    secret: merchantSecret,
  } = merchantSecretState;

  const [secretCopied, setSecretCopied] = useState(false);
  const [isSecretOpen, setIsSecretOpen] = useState(true);

  const maskedSecret = merchantSecret ? "*".repeat(merchantSecret.length) : "";

  useEffect(() => {
    if (token && merchantId) {
      dispatch(fetchMerchantSecret(token, merchantId) as any);
    }
  }, [token, merchantId, dispatch]);

  const handleRegenerateSecret = () => {
    if (!token || !merchantId) return;
    dispatch(regenerateMerchantSecret(token, merchantId) as any);
  };

  const handleCopySecret = async () => {
    if (!merchantSecret) return;
    try {
      await navigator.clipboard.writeText(merchantSecret);
      setSecretCopied(true);
      setTimeout(() => setSecretCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy secret", err);
    }
  };

  return (
    <Layout type="merchant">
      <div className="content-side access-api-page">
        <div
          id="payment-Dash-page"
          className="payment-Dash-page"
          style={{ marginTop: "58px" }}
        >
          <div className="access-card">
            <div className="access-card__header">
              <h2 className="access-card__title">Merchant Secret</h2>

              <button
                type="button"
                className="access-card__toggle"
                onClick={() => setIsSecretOpen((prev) => !prev)}
                aria-label={isSecretOpen ? "Collapse" : "Expand"}
              >
                <span
                  className={`chevron ${
                    isSecretOpen ? "chevron--up" : "chevron--down"
                  }`}
                />
              </button>
            </div>

            {isSecretOpen && (
              <div className="access-card__body">
                <div className="access-card__token-row">
                  <input
                    type="text"
                    className="access-card__token-input"
                    readOnly
                    value={maskedSecret}
                    placeholder={
                      secretLoading ? "Loading..." : "No secret generated yet"
                    }
                  />

                  <button
                    type="button"
                    className="access-card__icon-btn"
                    onClick={handleCopySecret}
                    disabled={!merchantSecret || secretLoading}
                    title="Copy secret"
                  >
                    📋
                  </button>

                  <button
                    type="button"
                    className="access-card__btn access-card__btn--primary"
                    onClick={handleRegenerateSecret}
                    disabled={secretLoading || !merchantId || !token}
                  >
                    {secretLoading ? "Loading..." : "Regenerate"}
                  </button>
                </div>

                {secretCopied && (
                  <div className="access-card__hint">
                    Secret copied to clipboard
                  </div>
                )}

                {secretError && (
                  <div className="access-card__hint access-card__hint--danger">
                    {secretError}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MerchantSecret;
